import { render } from "./AgilesStoreView.vue?vue&type=template&id=3853c7dd&scoped=true"
import script from "./AgilesStoreView.vue?vue&type=script&lang=js"
export * from "./AgilesStoreView.vue?vue&type=script&lang=js"

import "./AgilesStoreView.vue?vue&type=style&index=0&id=3853c7dd&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3853c7dd"]])

export default __exports__